import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=3fdaca63&scoped=true&"
import script from "./LanguageSelector.vue?vue&type=script&lang=js&"
export * from "./LanguageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdaca63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3358805848/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fdaca63')) {
      api.createRecord('3fdaca63', component.options)
    } else {
      api.reload('3fdaca63', component.options)
    }
    module.hot.accept("./LanguageSelector.vue?vue&type=template&id=3fdaca63&scoped=true&", function () {
      api.rerender('3fdaca63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Core/LanguageSelector.vue"
export default component.exports